import { pageTemplateConstants } from "../constants/pageTemplateConstants";
import { pageTemplateService } from "../../services/API/pageTemplateService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";

export const pageTemplateAction = {
  templateList,
  getPageTemplate,
  updateTemplate,
  executeContract,
};

export const templateList = postData => {
  return dispatch => {
    pageTemplateService.templateList(postData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: pageTemplateConstants.GET_TEMPLATELIST_REQUEST, data };
  }
  function success(data) {
    return { type: pageTemplateConstants.GET_TEMPLATELIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: pageTemplateConstants.GET_TEMPLATELIST_FAILURE, error };
  }
};

export const executeContract = postData => {
  return dispatch => {
    pageTemplateService.executeContract(postData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: pageTemplateConstants.POST_EXECUTE_REQUEST, data };
  }
  function success(data) {
    return { type: pageTemplateConstants.POST_EXECUTE_SUCCESS, data };
  }
  function failure(error) {
    return { type: pageTemplateConstants.POST_EXECUTE_FAILURE, error };
  }
};

export const updateTemplate = postData => {
  return dispatch => {
    pageTemplateService.updateTemplate(postData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: pageTemplateConstants.UPDATE_TEMPLATE_REQUEST, data };
  }
  function success(data) {
    return { type: pageTemplateConstants.UPDATE_TEMPLATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: pageTemplateConstants.UPDATE_TEMPLATE_FAILURE, error };
  }
};

export const getPageTemplate = templateType => {
  return dispatch => {
    pageTemplateService.getPageTemplate(templateType).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: pageTemplateConstants.GET_TEMPLATEDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: pageTemplateConstants.GET_TEMPLATEDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: pageTemplateConstants.GET_TEMPLATEDETAIL_FAILURE, error };
  }
};

export const saveFooterTemplate = postData => {
  return dispatch => {
    pageTemplateService.saveFooterTemplate(postData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: pageTemplateConstants.UPDATE_TEMPLATE_REQUEST, data };
  }
  function success(data) {
    return { type: pageTemplateConstants.UPDATE_TEMPLATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: pageTemplateConstants.UPDATE_TEMPLATE_FAILURE, error };
  }
};

export const saveHeaderTemplate = postData => {
  return dispatch => {
    pageTemplateService.saveHeaderTemplate(postData).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: pageTemplateConstants.UPDATE_TEMPLATE_REQUEST, data };
  }
  function success(data) {
    return { type: pageTemplateConstants.UPDATE_TEMPLATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: pageTemplateConstants.UPDATE_TEMPLATE_FAILURE, error };
  }
};

export const getFooterTemplate = templateType => {
  return dispatch => {
    pageTemplateService.getFooterTemplate(templateType).then(
      data => {
        dispatch(success(data));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: pageTemplateConstants.GET_TEMPLATEDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: pageTemplateConstants.GET_TEMPLATEDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: pageTemplateConstants.GET_TEMPLATEDETAIL_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/pageTemplateAction.js